export default __webpack_public_path__ + "static/media/Cape of Eleven Fallen Heroes.1f0fd2b2.jpg";